module.exports = __webpack_public_path__ + "img/bs6.a90c080f.png";